import { Slot } from '@radix-ui/react-slot';
import type { ComponentPropsWithoutRef, PropsWithChildren } from 'react';

import { cn } from '~/chords/lib/cn';
import { variants } from '~/chords/lib/variants';

export type MenuItemState = 'error' | 'warning' | 'success';

interface KebabMenuItemProps
  extends PropsWithChildren,
    Omit<ComponentPropsWithoutRef<'button'>, 'className'> {
  state?: MenuItemState;
  asChild?: boolean;
}

const kebabMenuItem = variants({
  base: cn(
    'px-md py-sm',
    'text-left text-body-sm text-default',
    'transition-colors duration-300 ease-out',
    'hover:bg-emphasis-subtle focus:bg-emphasis-subtle',
    'focus:outline-none',
  ),
  variants: {
    state: {
      error: cn('text-error-alert'),
      warning: cn('text-warning-default'),
      success: cn('text-success-default'),
    },
  },
});

export function KebabMenuItem({
  children,
  asChild,
  state,
  ...props
}: KebabMenuItemProps) {
  const Component = asChild ? Slot : 'button';

  return (
    <Component
      {...props}
      className={cn(kebabMenuItem({ state }))}
      onMouseEnter={(event) => {
        event.currentTarget.focus();
        props?.onMouseEnter?.(event);
      }}
    >
      {children}
    </Component>
  );
}

KebabMenuItem.displayName = 'KebabMenuItem';
